import { Component, Input } from '@angular/core';
import { Navigator } from 'src/app/components/menu/navigator';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { WithdrawalBaseComponent } from '../withdrawal-base/withdrawal-base.component';

@Component({
  selector: 'app-withdrawal-reverse-confirm',
  templateUrl: './withdrawal-reverse-confirm.component.html',
  styleUrls: ['./withdrawal-reverse-confirm.component.scss'],
})
export class WithdrawalReverseConfirmComponent extends WithdrawalBaseComponent {
    @Input() amount: any;
    @Input() payoutRequestID:any;
    @Input() navigateBackPage: string;
  
    public error = null;
    constructor(
        private withdrawService:WithdrawalService,
        public successMessageService:SuccessMessageService,
        private navigator:Navigator
    ) {
        super();
    }

  onReverseWithdraw() {
    let requestObj: any = {};
    requestObj.payoutRequestID = this.payoutRequestID;
    
    this.withdrawService.callReverseWithdrawal(requestObj).subscribe(
        (response: any) => {
            if (response && !!response.result ) {
                this.successMessageService.setMessage('Your withdrawal was successfully reversed.');
                // this.balanceProvider.updateBalance();
            }
        },
        (error) => {
            // handle all deposit errors in base
            this.error = this.handleError(error);
        }
    )

    this.error = null;
}

onBack = () => {
    if (!!this.navigateBackPage) {
        this.navigator.navigateTo(this.navigateBackPage);
    } else {
        this.navigator.back();
    }
}
}
